export default {
  'cart.title': '购物车',
  'cart.breadcrumb.home': '首页',
  'cart.totalCount': '共 {{count}} 件 / {{quantity}} 个商品',
  'cart.emptyCart': '清空购物车',
  'cart.emptyTitle': '购物车是空的',
  'cart.emptyDesc': '把喜欢的商品加入购物车，然后一次性申请报价吧。',
  'cart.browseProducts': '浏览商品',
  'cart.selectAll': '全选 ({{selected}}/{{total}})',
  'cart.deleteSelected': '删除所选',
  'cart.unitPrice': '单价',
  'cart.quoteInquiry': '报价咨询',
  'cart.amount': '金额',
  'cart.totalAmount': '总金额',
  'cart.totalUnits': '(共 {{count}} 个)',
  'cart.continueShopping': '继续购物',
  'cart.checkout': '下单',
  'cart.remove': '删除',
  'cart.toastSelectItem': '请选择要下单的商品',
};